import React, { FunctionComponent } from 'react'
import styles from './Switch.module.sass'
import clsx from 'clsx'
import { Classes } from '../../../styles'

interface Props {
    className?: string,
    value: boolean,
    text?: string,
    disabled?: boolean,
    onChange: (value: boolean) => void,
    reversed?: boolean,
}

const Switch: FunctionComponent<Props> = props => {
    return <div
        className={clsx(props.className, styles.switch, Classes.touchTarget, {
            [styles.reversed]: props.reversed,
            [styles.disabled]: props.disabled,
            [styles.active]: props.value,
        })}
        onClick={() => !props.disabled && props.onChange(!props.value)}
    >
        <div className={styles.element}/>
        {
            props.text && <div className={styles.text}>{props.text}</div>
        }
    </div>
}

export default Switch